module.exports = "varying vec2 f_uv;\r\nvoid main() {\r\n    f_uv = uv;\r\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/glsl/pass-vert.glsl
// module id = 14
// module chunks = 0